module.exports = "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAMCAYAAACNzvbFAAAABHNCSVQICAgIfAhkiAAAASNJREFUKFNjZACClJSUECYmJh0Qm1zw////f3///u2fN2/eZ0aQIRkZGdL//v07CWRKk2soUF/hrFmzJoD0gw0FgbS0NF0gdQSI+Ug1GOjKibNnzy6A6YMbChJITU11YWRk3AZkspJg8BIpKan4hoaGf1gNhbo4HkgvIMZQoAv33b592/3AgQN/kNWjuBQpKCqA7HYCBl/58+ePFShi0NVhNRQaFBOAQZGPzWCgC58BY9oUaOAzbPI4DQWGEdPTp0/XAA0ORNP4Fmigw9y5c6/g8glOQ0EaQkNDOQUEBPYBDbYA8YEu/AFMevZAA0/hCxq8hkIjTgRo2HGgwUpAOhCYdDYRikSChoIMSE5OVmFhYbGdOXPmfEIGguSJMpQYg5DVAADKpGoNUbmprQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bottom.jpg
// module id = T2Kr
// module chunks = 3